<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'MeasuriesOrgansProtectedMarket',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Органы, принимающие решения по мерам защиты рынка',
        canEdit: true,
        apiRoute: 'nsimeasureorganprotectedmarket',
        cardName: 'MeasureOrganProtectedMarketCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
